import { Eye, LogOut } from 'lucide-react'
import { useImpersonation } from '@/contexts/ImpersonationContext'

export function ImpersonationBanner() {
  const { isImpersonating, targetUser, endImpersonation } = useImpersonation()

  if (!isImpersonating || !targetUser) {
    return null
  }

  return (
    <div className="sticky top-0 z-50 flex items-center justify-between gap-4 bg-orange-500 dark:bg-orange-600 px-4 py-2 text-white shadow-md">
      <div className="flex items-center gap-2">
        <Eye className="h-4 w-4 flex-shrink-0" />
        <span className="text-sm font-medium">
          Viewing as: {targetUser.name} ({targetUser.role})
        </span>
      </div>
      <button
        onClick={endImpersonation}
        className="inline-flex items-center gap-1.5 rounded-md bg-white/20 px-3 py-1 text-sm font-medium text-white transition-colors hover:bg-white/30 focus:outline-none focus:ring-2 focus:ring-white/50"
      >
        <LogOut className="h-3.5 w-3.5" />
        Exit Impersonation
      </button>
    </div>
  )
}
